const DEFAULT_INV_CATS=[
  {name:"Public Equity",nameAr:"الأسهم المدرجة",listed:true,liquidity:"High"},
  {name:"Private Equity",nameAr:"الأسهم الخاصة",listed:false,liquidity:"Low"},
  {name:"Real Estate",nameAr:"العقارات",listed:false,liquidity:"Low"},
  {name:"Bonds",nameAr:"السندات",listed:true,liquidity:"Medium"},
  {name:"Funds",nameAr:"الصناديق",listed:true,liquidity:"Medium"},
  {name:"Cash",nameAr:"النقد",listed:false,liquidity:"High"},
];
/* Normalize legacy string[] categories to {name,nameAr,listed,liquidity}[] */
function normalizeInvCats(cats){
  if(!cats||!cats.length)return[];
  return cats.map(c=>{
    if(typeof c==="string")return{name:c,nameAr:"",listed:false,liquidity:"Medium"};
    return{nameAr:"",...c,liquidity:c.liquidity||(c.listed?"High":"Medium")};
  });
}

export { DEFAULT_INV_CATS, normalizeInvCats };
